<div class="wrapper" *ngIf="!hidden">
    <div class="header-text mb-2">Browse</div>
    <div class="browse-section">
        <div class="query-section">
            <ng-container *ngIf="this.settings.views && this.settings.views.length > 1">
                <div class="view-text">
                    View:
                </div>
                <div class="select-field">
                    <acl-ngx-select menuWidth="160px" (change)="handleOnViewChange($event)"
                        [initialValue]="{'value': currentSelectView}" [irreversible]="true">
                        <acl-ngx-option *ngFor="let view of settings.views" [value]="view.label">
                        </acl-ngx-option>
                    </acl-ngx-select>
                </div>
            </ng-container>
            <div class="input-section" [ngClass]="{'active': toggleFilterSelection}">
                <ng-container *ngIf="this.settings.filters && this.settings.filters.length > 0">
                    <acl-ngx-input compact="true" leftElement="Search" placeholder="Search" showRightElement="always"
                        [formControl]="searchString">
                        <div class="divider"></div>
                        <acl-ngx-button variant="borderless" icon="Filter" [label]="currentFilterLabel" compact="true"
                            (click)="toggleFilterSelection = !toggleFilterSelection"></acl-ngx-button>
                    </acl-ngx-input>
                </ng-container>
                <ng-container *ngIf="!this.settings.filters || this.settings.filters.length == 0">
                    <acl-ngx-input compact="true" leftElement="Search" placeholder="Search"
                        [formControl]="searchString">
                    </acl-ngx-input>
                </ng-container>
            </div>
        </div>
        <div class="list-section" [ngStyle]="{'height': selectionTableHeight}">
            <div class="table-section">
                <table class="table">
                    <thead class="thead-light">
                        <tr>
                            <th class="checkbox-header">
                                <acl-ngx-checkbox [indeterminate]="selectAllCheckboxIndeterminate"
                                    [checked]="selectAllCheckboxChecked" [disabled]="_data.length == 0"
                                    [hidden]="hideSelectAllCheckbox"
                                    (checkedChange)="handleOnSelectionChanged($event, true)">
                                </acl-ngx-checkbox>
                            </th>
                            <th *ngFor="let column of currentViewColumns" [ngStyle]="{'width': column.width}">
                                {{column.header}}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let d of _data">
                            <td>
                                <acl-ngx-checkbox [checked]="d.checked"
                                    (checkedChange)="handleOnSelectionChanged($event, false, d)">
                                </acl-ngx-checkbox>
                            </td>
                            <td *ngFor="let column of currentViewColumns">
                                {{column.accessor(d)}}
                                <div class="subtext" *ngIf="column.subtextAccessor">
                                    {{column.subtextAccessor(d)}}
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div class="null-state-text" *ngIf="selectionTableNullStateText && !_data.length">
                    <span>{{ selectionTableNullStateText }}</span>
                </div>
            </div>
            <div class="filter-section" [ngClass]="{'hidden': !toggleFilterSelection}">
                <ng-container *ngFor="let filter of this.settings.filters">
                    <div class="font-weight-bold mb-2">{{filter.label}}</div>
                    <ng-container *ngIf="filter.filterType == 'checkbox'">
                        <ng-container *ngFor="let option of filter.options">
                            <acl-ngx-checkbox [label]="option.label"
                                (checkedChange)="handleOnFilterChanged(filter, option, $event)">
                            </acl-ngx-checkbox>
                        </ng-container>
                    </ng-container>
                    <ng-container *ngIf="filter.filterType == 'radio'">
                        <acl-ngx-radio [value]="radioNoneValue"
                            [checked]="!filter.currentSelected || filter.currentSelected === radioNoneValue"
                            (change)="handleOnFilterChanged(filter, {value: radioNoneValue})">None
                        </acl-ngx-radio>
                        <ng-container *ngFor="let option of filter.options">
                            <acl-ngx-radio [value]="option.value" [checked]="filter.currentSelected === option.value"
                                (change)="handleOnFilterChanged(filter, option)">{{option.label}}
                            </acl-ngx-radio>
                        </ng-container>
                    </ng-container>
                    <ng-container *ngIf="filter.filterType == 'autoComplete'">
                        <auto-complete [fetchData]="filter.onFilterSearchStringChanged"
                            [searchProps]="autoCompleteSearchProps" [initialValue]="filter.currentSelected"
                            width="200px" height="200px" (onSelect)="handleOnFilterChanged(filter, $event, true)"
                            (onClickOutside)="handleOnClickOutside(filter, $event)">
                        </auto-complete>
                        <ng-container *ngIf="!filter.autoCompleteSingleSelection">
                            <ng-container *ngFor="let selection of filter.currentAutoCompleteSelection">
                                <acl-ngx-chip [text]="selection.label"
                                    (close)="handleOnFilterChanged(filter, selection, false)">
                                </acl-ngx-chip>
                            </ng-container>
                        </ng-container>
                    </ng-container>
                </ng-container>
            </div>
        </div>
    </div>
    <div class="selected-heder-section">
        <div class="header-text">Selected</div>
        <acl-ngx-button variant="borderless" label="Reset" (click)="handleOnRemoval(true)"></acl-ngx-button>
    </div>
    <div class="selected-section">
        <div class="list-section" [ngStyle]="{'height': selectedTableHeight}">
            <div class="table-section">
                <table class="table">
                    <thead class="thead-light">
                        <tr>
                            <th *ngFor="let column of currentSelectedViewColumns" [ngStyle]="{'width': column.width}">
                                {{column.header}}
                            </th>
                            <th class="removeButton">
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let d of _selectedData; let index = index" (mouseenter)="onMouseEnterSelectedRow(d)"
                            (mouseleave)="onMouseLeaveSelectedRow(d)">
                            <td *ngFor="let column of currentSelectedViewColumns">
                                {{column.accessor(d)}}
                                <div class="subtext" *ngIf="column.subtextAccessor">
                                    {{column.subtextAccessor(d)}}
                                </div>
                            </td>
                            <td>
                                <ng-container *ngIf="d.showDeleteButton">
                                    <acl-ngx-button variant="borderless" icon="CloseSmall" ultraCompact="true"
                                        (click)="handleOnRemoval(false, d, index)"></acl-ngx-button>
                                </ng-container>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div class="null-state-text" *ngIf="selectedTableNullStateText && !_selectedData.length">
                    <span>{{ selectedTableNullStateText }}</span>
                </div>
            </div>
        </div>
    </div>
</div>